// extracted by mini-css-extract-plugin
export default {"content":"ServiceDetail_content__uv7Zk"};